// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e872cc58","865":"ec376abe"}[chunkId] + ".chunk.js";
};